import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal } from 'antd';
import './newMessage.css';
import PropTypes from 'prop-types';

import rightImg from '../../public/img/newMessage/Right.png'
import rejectImg from '../../public/img/newMessage/Reject.png'
import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let NewMessage = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [statusFlag, setStatusFlag] = useState(true);
    const [textJustifyFlag, setTextJustifyFlag] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
            setStatusFlag,
            setTextJustifyFlag,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            wrapClassName='newMessage'
            width={735}
            centered
            closable={false}
        >
            {statusFlag ?
                <img src={rightImg} className='rightImg' />
                :
                <img src={rejectImg} className='rightImg' />
            }

            <div className={'contentBox ' + (textJustifyFlag ? 'textJustify' : '')}>
                {content}
            </div>
            {statusFlag ?
                <div className='doneButton' onClick={props.done}><img src={asReviewWpaFormConfim} />Done</div>
                :
                <div className='doneButton' onClick={props.done}><img src={asReviewWpaFormConfim} />Done</div>
            }
        </Modal>
    )

}

NewMessage = forwardRef(NewMessage);

NewMessage.propTypes = {
    done: PropTypes.func.isRequired,
};

export default NewMessage;